// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-subtitled-item[data-v-5b008e22] {\n  max-width: 120px;\n}\n.container-subtitled-item a[data-v-5b008e22] {\n  color: inherit;\n}\n.subtitled-item[data-v-5b008e22] {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 50px;\n  height: 20px;\n}", ""]);
// Exports
module.exports = exports;
